import { render, staticRenderFns } from "./OffenePostenBuchung.vue?vue&type=template&id=017ba966&scoped=true&"
import script from "./OffenePostenBuchung.vue?vue&type=script&lang=js&"
export * from "./OffenePostenBuchung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017ba966",
  null
  
)

export default component.exports